module.exports = __webpack_public_path__ + "static/img/sist.351830f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/clients/sist.png
// module id = 5fOW
// module chunks = 1